import { useContext, useEffect } from 'react';
import { Button } from 'react-bootstrap';
import { useHistory } from 'react-router';
import styled, { useTheme } from 'styled-components';

import CheckMark from '../../assets/svg/disc/check-disc.svg';
import { OnboardingContext } from '../../context/OnboardingContext';
import { useActiveSubscription } from '../../hooks';
import { BasicSpinner } from '../../ui';
import { min } from '../../utils/breakpoints';

const StyledImg = styled.img`
  width: 50px;

  ${min.sm} {
    width: 80px;
  }
`;

const ConnectedContainer = () => {
  const theme = useTheme();
  const history = useHistory();
  const { isPolling, error } = useActiveSubscription({ poll: true });
  const { setProgressPercentage } = useContext(OnboardingContext);

  useEffect(() => {
    setProgressPercentage(100);
  }, []);

  let statusMessage;
  if (isPolling) {
    statusMessage = (
      <div className="text-center">
        Fetching details... <BasicSpinner />
      </div>
    );
  } else if (error) {
    statusMessage = <span className="text-danger">{error.message}</span>;
  } else {
    statusMessage = <span>Your {theme.language.appName} account is now ready to use.</span>;
  }

  return (
    <>
      <h1 className="mb-3">All set</h1>
      <div className="mt-1 mb-4">
        <StyledImg src={CheckMark} alt="Success checkmark" />
      </div>
      <p className="mb-0">{statusMessage}</p>
      {!isPolling && !!error ? (
        <Button variant="secondary" className="mt-4" onClick={() => window.location.reload()}>
          Retry
        </Button>
      ) : (
        <Button className="mb-2" onClick={() => history.push('/app/today')} disabled={isPolling || !!error}>
          Continue
        </Button>
      )}
    </>
  );
};

export default ConnectedContainer;
